export const siteConfigHelper = () => {
  let urlSection = 'sections=SITEWIDE';

  if (window.location.pathname === '/' || window.location.pathname === '/100m') {
    urlSection += '&sections=LANDING';
  } else if (window.location.href.includes('summary')) {
    urlSection += '&sections=SUMMARY';
  } else if (window.location.href.includes('donate') || window.location.pathname.includes('cart')) {
    urlSection += '&sections=DONATE';
  } else if (window.location.href.includes('profile')) {
    urlSection += '&sections=PROFILE';
  } else if (window.location.href.includes('impact')) {
    urlSection += '&sections=IMPACT_SCORE';
  } else if (window.location.href.includes('autopilot')) {
    urlSection += '&sections=AUTOPILOT';
  }

  return { urlSection };
};
